import { PAT_FACILITATOR_CNPJ, PAT_FACILITATOR_CORPORATE_NAME, PAT_REGISTRATION_NUMBER } from '../../constants';
export function buildPatFacilitatorClipboardText(labels) {
    return [
        `${labels.registration}: ${PAT_REGISTRATION_NUMBER}`,
        `${labels.corporateName}: ${PAT_FACILITATOR_CORPORATE_NAME}`,
        `${labels.cnpj}: ${PAT_FACILITATOR_CNPJ}`,
    ].join('\n');
}
